<!--  -->
<template>
  <div>
    <div class="sign_up" :style="temData.hasBorder ? setStyle:''">
      <a href="javascript:;" :class="['sign_up__btn',{'inside_register':isInsideRegister}]" @click="showDialog" ref="loginText" :style="setBgColor">{{regText}}</a>
    </div>
    <transition name="fade">
    <div class="dialog" v-if="dialogVisible">
      <div class="dialog_content">
        <div class="dialog_content_reg">
          <CpLogin
            :showList="showList"
            :groups='groups'
            :requiredList="requiredList"
            :showExtItems="showExtItems"
            :requiredExtItems="requiredExtItems"
            :color='globalConfig.vice'
            @regSucces="regSucces"
            @regClose="regClose"
            @registClose='registClose'
            @serialSignUp='serialSignUp'
            :competitionId="id"
            :isReview="true"
            :tip="tip"
            bgUrl="#fff"
            show="reg"
            :loginType='loginType'
            :serialType='serialType'
            :userType='userType'
          />
        </div>
      </div>
  </div>
  </transition>
  <SignUpSuccess :dialogVisible.sync='dialogSignUpSuccessVisible' :onSuccess='onKnowSuccess'></SignUpSuccess>
  </div>
</template>

<script>
// import {getPathNameUrl} from '@/utils/query-string.js'
import { mapState, mapGetters,mapActions } from "vuex";
import { getIsRegister,insideRegister } from '@/services/home'
import SignUpSuccess from '../../components/SignUpSuccess'
import { errorHandler } from '@/utils/errorHandler';

import { getRegInfo,serialSignUp } from '@/services/user';
export default {
  props: {
    temData: {
      type: Object
    }
  },
  
  data () {
    return {
    dialogVisible:false,
    isInsideRegister:false,
    dialogSignUpSuccessVisible:false,
    currentRegInfo:{},
    regTextObj:{
      1:'报名未开始',
      2:'立即报名',
      3:'报名结束'
    },
    regText:''
    };
  },
  watch:{
    loginStatus(newVal){
      if(newVal && (this.loginType === 1 || this.isSerial)) return this.isRegister()
      // if(newVal && ) return this.isRegister()
      this.isInsideRegister = false;
      this.regTextMeth();
      // this.regText = '立即报名';
      // this.$refs.loginText.innerHTML = '立即报名';
    },
    isInsidSignUp:{
      handler() {
        if(this.loginStatus && this.loginType === 1 || this.loginStatus && this.isSerial){
          this.isRegister()
        }
      },
      immediate: true
    },
    isRegDiaLog(newVal){
      newVal && this.showDialog()
    }
  },
  mounted(){
    if(this.loginStatus && this.loginType === 1 || this.loginStatus && this.isSerial){
      this.isRegister()
    }
    this.regTextMeth();
    window.addEventListener('message', this.receiveMessage, false);
  },
  components: {
    SignUpSuccess
  },

  computed: {
    ...mapState({
      id: state => JSON.parse(state.router.id),
      loginType:state=>state.router.loginType,
      globalConfig: state => state.router.globalConfig,
      isInsidSignUp:state => state.user.isInsidSignUp,
      isRegDiaLog:state => state.user.isRegDiaLog,
      isSerial:state=>state.router.isSerial,
      serialType:state=>state.user.serialType,
    }),
    setStyle(){
      const border = {
        'border-width': '1px',
        'border-style': 'solid',
        'border-radius': '8px'
      }
      return{
        borderColor:this.globalConfig.vice,
        ...border
      }
    },
    ...mapGetters(['loginStatus','tokenKey']),
    requiredList() {
      const { requiredItems } = this.currentRegInfo;
      if (requiredItems) {
        return JSON.parse(requiredItems)
      }
      return [];
    },
    showList() {
      const { showItems } = this.currentRegInfo;
      if ( showItems) {
        return JSON.parse(showItems)
      }
      return [];
    },
    showExtItems() {
      const { extItems } = this.currentRegInfo;
      if ( extItems) {
        return JSON.parse(extItems).filter(item => item.isShow)
      }
      return [];
    },
    requiredExtItems() {
      const { extItems } = this.currentRegInfo;
      if ( extItems) {
        return JSON.parse(extItems).filter(item => item.required)
      }
      return [];
    },
    groups() {
      const { groups } = this.currentRegInfo;
      if ( groups) {
        return groups
      }
      return [];
    },
    tip() {
      try {
        return this.currentRegInfo.tip
      } catch (error) {
        return ''
      }
    },
    bgUrl() {
      return this.temData.bgDataUrl
    },
    setBgColor(){
      return{
        'backgroundColor':this.globalConfig.vice,
        'color':this.globalConfig.main
      }
    },
    userType(){
      if(this.isSerial) return 'serial';
      return 'reg'
    },
    registerStatus(){
      return this.temData.moduleRegister.registerStatus
    },

  },

  methods: {
    ...mapActions(['setSmsSend','setUserDiaLog','setRegDiaLog','setSerialType']),

    regTextMeth(){
     this.regText = this.regTextObj[this.registerStatus] //1（报名未开始）、2（报名开始）、3（报名结束）
    },

    handleClose(){
      this.dialogVisible = false;
      this.regClose()
      this.setRegDiaLog(false)

    },
    registClose(){
      this.regClose()
    },
    filterOption(arr, type) {
      if (type === 'show') {
        return arr.filter(item => item.isShow)
      }
      return arr.filter(item => item.required)
    },
    showDialog(){
      // 已报名 || （报名未开始||报名已结束）
      if(
        this.isInsideRegister && this.isSerial || 
        [1,3].includes(this.registerStatus)
      ) return;

        // 未登录 + 内部 || 未登录 + 系列赛 =>登录
      if(!this.loginStatus && this.loginType === 1 || !this.loginStatus && this.isSerial) {
        return this.setUserDiaLog({isShowDiaLog:true,currentVal:'login'})
      }
      // 登录 + 内部 + 未报名 =>报名
      if(this.loginStatus && this.loginType === 1 && !this.isInsideRegister){
        // this.insideRegister()
        this.getCurrentRegInfo()
      }
      // 登录 + 系列赛 + 未报名 => 报名
      if(this.loginStatus && this.isSerial && !this.isInsideRegister){
        this.setSerialType('2')
        this.getCurrentRegInfo()
        return;
      }
      
      // 外部
      if(this.loginType === 2){
        this.getCurrentRegInfo()
      }
    },
    // 系列赛 + 报名
    async serialSignUp(info){
      try {
        let { status } = await serialSignUp(info)
        if(status === 200) {
          this.regClose()
          this.dialogSignUpSuccessVisible = true;
        }
      } catch (error) {
        this.$message.showMessage({info: error.data.message})
        this.regClose()
      }
      
      
    },

    async getCurrentRegInfo(){
      const res = await getRegInfo(this.id)
      
      this.currentRegInfo = res.data;
      this.dialogVisible = true;
    },

    async isRegister(){
      let {status,data} = await getIsRegister(this.id);
      if(status === 200){
        this.isInsideRegister = data;
        this.$store.dispatch('setInsidSignUp', data)
        if(this.isInsideRegister && this.registerStatus === 2) this.regText = '已报名';
      }
    },
    onKnowSuccess(){
       this.$store.dispatch('setInsidSignUp', true)
      // setTimeout(() => {
      //   window.location.reload()
      // },500);
    },
    async insideRegister(info){
      try {
         let {status} = await insideRegister(info);
        if(status === 200){
          if(this.loginStatus){
              // this.$store.dispatch('saveUserInfo',{data})
              this.dialogSignUpSuccessVisible = true;
            }
        }
      } catch ({ data }) {
        errorHandler(data);
      }
     
    },
    regSucces(data) {
      if(this.loginType === 1) this.insideRegister(data)
      if(this.loginType === 2) this.$store.dispatch('saveUserInfo', data)
      // this.dialogSignUpSuccessVisible = true;
      this.regClose()
      // this.$router.push({
      //   path: '/cpFlow'
      // })
      // if(getPathNameUrl() && getPathNameUrl().includes('noc')) return this.setSmsSend(true)
    },
    regClose() {
      this.dialogVisible = false;
      this.setRegDiaLog(false)
      this.$emit('regClose')
    },
  },
}

</script>
<style lang='less' scoped>
.sign_up{
  width: 1100px;
  height: 164px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  .sign_up__btn{
    width: 240px;
    height: 64px;
    text-align: center;
    line-height: 64px;
    background: #F2C10C;
    color:#333;
    border-radius:32px;
    // border:2px solid #F2C10C;
    box-sizing: border-box;
    font-size: 24px;
    transition:all .1s ease;
    &:hover{
      transform: scale(1.1);
      background: #EDAB03;
      color:#fff;
      // border:2px solid #EDAB03;
    }
    &.inside_register{
      background: #BEBEBE;
      // border:2px solid #A2A2A2;
      color:#fff;
    }
  }
}
.dialog{
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left:0;
	z-index: 99;
	background-color:rgba(12,12,12,.616);
	color: #333;
	.dialog_content{
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width:562px;
		background:#fff;
		border-radius:6px;
    box-shadow: border-box;
		.header{
			position: relative;
			.header_title{
				text-align: center;
				padding:25px 0 0;
				font-size:24px;
				color:#333;
				margin:0;
			}
			.header_title_close{
				position: absolute;
				top:10px;
				right:10px;
				width:18px;
				height: 18px;
				text-align: center;
				line-height: 18px;
				color:#333;
				margin:0;
				font-size: 24px;
        cursor: pointer;
        background: url('../../assets/competition_close.png') no-repeat;
        background-size: 100% 100%;
			}
    }
	}
	.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>